var parent = require('../../actual/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/object/assign.js
// module id = 3487
// module chunks = 25